import React from 'react'
import './SearchSubmitButton.scss'

const SearchSubmitButton = ({
  text,
  onClick,
  isExternalLink = false,
  forceStacked = false,
  disabled = false,
}) => {
  return (
    // TODO: eslint (react/button-has-type): should this submit a form? then button="submit", else button="button"
    // eslint-disable-next-line react/button-has-type
    <button
      className={`SearchSubmitButton ${forceStacked ? 'force-stacked' : ''}`}
      onClick={onClick}
      disabled={disabled}
    >
      {text}
      {isExternalLink && <span className="external-link-icon" />}
    </button>
  )
}

export default SearchSubmitButton
